import { render, staticRenderFns } from "./Sale14.1.vue?vue&type=template&id=52e45c40&"
import script from "./Sale14.1.vue?vue&type=script&lang=js&"
export * from "./Sale14.1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports